import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative w-full py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20golden%20and%20amber%20organic%20flowing%20shapes%2C%20subtle%20luxurious%20texture%2C%20modern%20minimal%20digital%20art%2C%20smooth%20elegant%20curves%2C%20professional%20atmosphere%2C%20no%20text%20no%20people%2C%20high%20quality%20rendering&width=1800&height=600&seq=cta-footer-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-xl mx-auto animate-fade-in-up">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-4">
            准备好开始使用 JavBus 了吗？
          </h2>
          <p className="text-white/70 text-sm md:text-base mb-6 leading-relaxed">
            获取最新的访问入口与完整的平台使用教程，让您的检索体验更加高效顺畅。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/latest-address"
              className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-accent-500 text-white font-medium text-sm rounded-md hover:bg-accent-600 transition-colors"
            >
              立即访问最新地址
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-white/15 backdrop-blur-sm text-white font-medium text-sm rounded-md hover:bg-white/25 transition-colors"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}